
































































import {Component, Prop, Vue} from 'vue-property-decorator'

import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue'

import {designStore} from "@/store/store";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import {findZr} from "@/modules/design/lib/calculations/calculationUtils";
import {IAcOverlayDesignImperial, IAcOverlayDesignMetric} from "@/modules/design/interfaces/acOverlay";
import {Route} from "vue-router";
import {createAcOverlayValidations} from "@/modules/design/lib/validations/acOverlay";
import ValidatedInputPageWrapper from "@/views/components/input/ValidatedInputPageWrapper.vue";


@Component({
  components: {
    ValidatedInputPageWrapper,
    PxDropdown,
    PxNumberInput,
    InputPageWrapper
  },
  // validations: {
  //
  //   deltaServiceability: {
  //     between: between(0, 5)
  //   },
  //   scenario: {
  //     designPeriod_years: {
  //       required,
  //       minValue: minValue(0)
  //     },
  //     reliabilityLevel: {
  //       required
  //     },
  //     standardError: {
  //       required,
  //       between: between(0, 1)
  //     },
  //     initialServiceability : {
  //       required,
  //       between: between(0, 5)
  //     },
  //     terminalServiceability :{
  //       required,
  //       between: between(0, 5)
  //     }
  //   }
  // }
})
export default class AcOverlayDesignParameters extends Vue {
  @Prop() readonly pxDesignId!: string;
  @Prop() readonly page!: number;

  get scenario(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    return designStore.currentAcOverlay;
  }

  get scenarioImperial() {
    return designStore.currentAcOverlayImperial
  }

  save() {
    this.sync();
    designStore.saveCurrentAcOverlayScenario()
  }

  validations() {
    return createAcOverlayValidations(this.scenarioImperial)
  }

  sync() {
    designStore.setCurrentAcOverlayScenario(this.scenario)
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next()
  }

  get numLayers() {
    // Required for validating whether the user has created any layers.
    return this.scenarioImperial.existingLayers.length;
  }


  reliabilityOptions: { value: number, text: string }[] = [
    {value: 50, text: '50%'},
    {value: 60, text: '60%'},
    {value: 70, text: '70%'},
    {value: 75, text: '75%'},
    {value: 80, text: '80%'},
    {value: 85, text: '85%'},
    {value: 90, text: '90%'},
    {value: 95, text: '95%'},
    {value: 99, text: '99%'},
  ];

  get zr() {
    const zr = findZr(this.scenario.reliabilityLevel || 50)
    console.log(zr);
    return zr
  }

  get deltaServiceability(): number | null {
    if (this.scenario.terminalServiceability !== null && this.scenario.initialServiceability !== null) {
      this.scenario.deltaServiceability = this.scenario.terminalServiceability - this.scenario.initialServiceability;
      return Math.abs(this.scenario.deltaServiceability)
    }
    return null
  }

}
